var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';

import SearchResults from "../../Connections/components/SearchResults";

import SearchInput from "../../Layout/SearchInput";
import debounce from "../../utils/debounce";
import { RequestParams } from "../../utils/RequestParams";

import Immutable from 'immutable';
import SearchApi from "../../Search/SearchAPI";













export class SearchEntities extends Component {
  constructor(props) {
    super(props);
    this.state = { searchResults: Immutable.fromJS([]), searching: false, touched: false };
    this.onSelect = this.onSelect.bind(this);
    this.search = this.search.bind(this);
    this.onChange = debounce(this.onChange.bind(this), 400);
  }

  componentDidMount() {
    if (this.props.initialSearchTerm) {
      this.search(this.props.initialSearchTerm);
    }
  }

  onSelect(_sharedId, entity) {
    this.props.onSelect(entity);
  }

  onChange(e) {
    this.setState({ touched: true });
    const searchTerm = e.target.value;
    return this.search(searchTerm);
  }

  search(searchTerm) {
    this.setState({ searching: true });
    const requestParams = new RequestParams({
      searchTerm,
      fields: ['title'],
      includeUnpublished: true
    });

    return SearchApi.search(requestParams).then(
      ({ rows: searchResults }) => {
        this.setState({
          searchResults: Immutable.fromJS(searchResults),
          searching: false
        });
        this.props.onFinishSearch(searchTerm);
      }
    );
  }

  render() {
    const { searchResults, searching } = this.state;
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(SearchInput, {
        onChange: this.onChange,
        value: !this.state.touched ? this.props.initialSearchTerm : undefined }
      )
      ), /*#__PURE__*/
      _jsx(SearchResults, { results: searchResults, searching: searching, onClick: this.onSelect })
      ));

  }
}